var map = {
	"./data_logo.png": 177,
	"./flappy_bird.png": 368,
	"./flappy_bird_gameplay.jpg": 780,
	"./kth_logo.png": 207,
	"./led_frack.png": 579,
	"./logo.png": 949,
	"./patch_sjoslaget_2023.png": 376,
	"./profile.png": 254,
	"./ray_tracer.png": 870,
	"./scroll_me.png": 350,
	"./spotify.png": 315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;